<fieldset class="effective-from">
  <legend class="effective-from__legend">
    <span>{{ 'installations.editor.effectiveFrom.label' | translate }}</span>
    @if (hint(); as text) {
      <span
        class="effective-from__hint"
        [class.effective-from__hint--broken]="ruleBroken()"
        data-testid="effective-from-hint"
        >{{ text }}</span
      >
    }
  </legend>
  <div class="effective-from__fields">
    <xemex-date-field
      class="effective-from__date"
      [label]="'installations.editor.effectiveFrom.date' | translate"
      [ngModel]="date()"
      (ngModelChange)="onDate($event)"
    />
    <mat-form-field class="effective-from__time">
      <mat-label>{{ 'installations.editor.effectiveFrom.time' | translate }}</mat-label>
      <input
        matInput
        [matTimepicker]="timepicker"
        [ngModel]="time()"
        (ngModelChange)="onTime($event)"
      />
      <mat-timepicker-toggle matIconSuffix [for]="timepicker" />
      <mat-timepicker #timepicker />
    </mat-form-field>
  </div>
  <p class="effective-from__zone text-text-secondary">
    {{ 'installations.editor.effectiveFrom.zone' | translate: { zone: timeZone() } }}
  </p>
  @if (error(); as messageKey) {
    <p class="effective-from__error text-text-error" role="alert">{{ messageKey | translate }}</p>
  }
  @if (!hint()) {
    <p class="effective-from__rule text-text-secondary">
      {{ 'installations.editor.effectiveFrom.rule' | translate }}
    </p>
  }
</fieldset>
